import { Container, Grid, Skeleton, Card, CardContent, Box } from '@mui/material';

const DashboardSkeleton = () => (
  <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3 }, py: { xs: 3, sm: 4 } }}>
    {/* Header */}
    <Box display="flex" justifyContent="space-between" mb={3}>
      <Skeleton variant="text" width="30%" height={40} />
      <Skeleton variant="rounded" width={100} height={32} />
    </Box>

    {/* KPI Cards */}
    <Grid container spacing={2} sx={{ mb: 3 }}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Grid item xs={6} sm={4} md key={i}>
          <Skeleton variant="rounded" height={100} sx={{ borderRadius: 3 }} />
        </Grid>
      ))}
    </Grid>

    {/* Charts Row 1 */}
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid item xs={12} md={8}>
        <Skeleton variant="rounded" height={340} sx={{ borderRadius: 3 }} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Skeleton variant="rounded" height={340} sx={{ borderRadius: 3 }} />
      </Grid>
    </Grid>

    {/* Charts Row 2 */}
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid item xs={12} md={6}>
        <Skeleton variant="rounded" height={300} sx={{ borderRadius: 3 }} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Skeleton variant="rounded" height={300} sx={{ borderRadius: 3 }} />
      </Grid>
    </Grid>

    {/* Status + Table */}
    <Skeleton variant="rounded" height={60} sx={{ borderRadius: 3, mb: 3 }} />
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Card><CardContent>
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} variant="text" height={44} sx={{ mb: 0.5 }} />
          ))}
        </CardContent></Card>
      </Grid>
      <Grid item xs={12} md={4}>
        <Skeleton variant="rounded" height={280} sx={{ borderRadius: 3 }} />
      </Grid>
    </Grid>
  </Container>
);

export default DashboardSkeleton;
